export default "__VITE_ASSET__Pw3Ef2AP__"